import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Checkbox,
  Box,
  styled,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const StyledCard = styled(Card)(({ theme, selected }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: 'pointer',
  border: selected ? '2px solid #35b258' : '1px solid #e0e0e0',
  boxShadow: selected
    ? '0 8px 24px rgba(53, 178, 88, 0.15)'
    : '0 2px 8px rgba(0,0,0,0.05)',
  backgroundColor: selected ? '#f0fdf4' : '#ffffff',
  borderRadius: '16px',
  overflow: 'visible',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 28px rgba(0,0,0,0.1)',
    borderColor: '#35b258',
  },
}));

const SelectionOverlay = styled(Box)(({ selected }) => ({
  position: 'absolute',
  top: 12,
  right: 12,
  zIndex: 2,
  color: selected ? '#35b258' : '#bdbdbd',
  transition: 'color 0.2s ease',
}));

const CandidateAvatar = styled(CardMedia)(({ theme }) => ({
  width: 120,
  height: 120,
  borderRadius: '50%',
  margin: '24px auto 16px',
  border: '4px solid #fff',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  objectFit: 'cover',
  backgroundColor: '#f5f5f5',
}));

const CandidateCard = ({ candidate, selected, onSelect }) => {
  return (
    <StyledCard selected={selected} onClick={onSelect} elevation={0}>
      <SelectionOverlay selected={selected}>
        {selected ? (
          <CheckCircleIcon sx={{ fontSize: 32 }} />
        ) : (
          <RadioButtonUncheckedIcon sx={{ fontSize: 32 }} />
        )}
      </SelectionOverlay>
      
      <CandidateAvatar
        image={candidate.profile_img_url || '/default-profile.png'}
        title={candidate.full_name}
        component="img"
      />
      
      <CardContent sx={{ textAlign: 'center', pb: 3, px: 2, flexGrow: 1 }}>
        <Typography 
          variant="h6" 
          component="div" 
          sx={{ 
            fontWeight: 700, 
            mb: 1,
            color: '#1a1a1a',
            fontSize: '1.1rem',
            lineHeight: 1.3
          }}
        >
          {candidate.full_name}
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            fontSize: '0.875rem',
            lineHeight: 1.5
          }}
        >
          {candidate.info || 'No verification info provided'}
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

export default CandidateCard;
